import dayjs from 'dayjs';
import { ApiResponse } from '../@types/ApiResponse';
import { displayCascadeValue } from '../operation';

const { isArray, isEmpty } = require('lodash');
const { FILTER_UNSET } = require('../constants');
const { propIsNull } = require('../operation');
const { getMatchingOriginProp } = require('./prop');
const { getDefaultStatus } = require('./status');

export const transformCondition = () => {};

export const transformGroupBy = (groupBy: any, groupOption: any, template: any) => {};

export const transformViewOption = {
  condition: transformCondition,
  groupBy: transformGroupBy,
  orderByKey: () => {},
};

/**
 * 通过视图分组新增节点时，新节点的继承数据
 * @param {*} condition 视图筛选条件
 * @param {*} groupBy 视图分组条件
 * @param groupData 分组数据
 * @param template 模板数据
 */
export const getAddNodeDataWithViewOption = (
  condition: ApiResponse.ViewList.Viewcondition[],
  groupBy = '',
  groupData: ViewGroupDataItem,
  template: ApiResponse.CurrentUser.TemplateInfo,
  groupKey: string = '',
  brotherNode: PiNode,
) => {
  groupBy = groupBy || '';
  groupData = groupData || {};
  // 过滤项和分组项都是下面的可选
  // templateStatus 状态
  // templateProp_${tempId}_${index} 模板属性
  // templateStatusPropBase_${index} 基础状态属性4个
  // templateStatusPropCustom_${tempId}_${status}_${index} 其他状态属性
  // sysCreator || _sys_creator 创建人
  // _sys_createTime 创建时间

  // 先处理需要变更的数据到 changeFields
  const changeFields = [];
  // 1.过滤项
  condition.map((x, i) => {
    if (
      !x ||
      x.key === 'templateId' ||
      (~x.key.indexOf('_sys') && x.key !== '_sys_tag') ||
      x.key === 'sysCreator' ||
      isEmpty(x.value)
    ) {
      // 模板id和系统属性不需要处理
      return;
    }

    const conditionValue = Array.isArray(x.value)
      ? x.value.filter((a) => a !== FILTER_UNSET)
      : [x.value];
    if (!conditionValue.length) return;
    if (x.key === 'templateStatus') {
      let value = conditionValue[0];
      changeFields.push({
        type: 'templateStatus',
        value: Number(value.split('_')[1]),
        orgin: 'condition',
      });
    }
    // condition属性
    if (~x.key.indexOf('templateProp_')) {
      const [_, __, propIndex] = x.key.split('_');
      const propInfo = template.prop[Number(propIndex)];

      // transformViewOptionPropData 可能返回多个需要被修改的值（公式计算源）
      const needChangeValues = transformViewOptionPropData(
        template,
        Number(propIndex),
        propInfo,
        conditionValue,
        brotherNode?.tempInfo?.prop || [],
      );
      needChangeValues.map((x) => {
        const propConfig = template.prop[x.propIndex as number];

        const field: any = {
          type: 'templateProp',
          value: x.value,
          index: x.propIndex,
          orgin: 'condition',
        };
        if (propConfig?.type === 'cascade') {
          // 多级选值要添加 _sys_cascade
          const titles = displayCascadeValue({
            value: x.value,
            cascadeMap: propConfig?.cascade?.nodesMap,
            multiple: propConfig.multiple,
            hideRoutes: propConfig.hideRoutes,
          });
          field['sysCascade'] = titles;
        }
        changeFields.push(field);
      });
      // changeFields.push({
      //   type: 'templateProp',
      //   value:transformViewOptionPropData(template,propIndex,propInfo,conditionValue),
      //   index: propIndex,
      //   orgin: 'condition',
      // });
    }
    if (~x.key.indexOf('templateStatusPropBase_')) {
      const [_, propIndex] = x.key.split('_');
      if (Number(propIndex) < 2) {
        // 只有负责人和参与者需要继承
        changeFields.push({
          type: 'tempStatusProp',
          value: conditionValue,
          index: propIndex,
          orgin: 'condition',
        });
      }
    }
    // 模板状态属性，需要在确定状态的时候，才能赋值
    if (~x.key.indexOf('templateStatusPropCustom_')) {
      const [_, __, ___, propIndex] = x.key.split('_');
      changeFields.push({
        type: 'tempStatusProp',
        index: propIndex,
        value: conditionValue,
        orgin: 'condition',
      });
    }
    // 系统标签
    if (x.key === '_sys_tag') {
      const tags = x.value || [];
      changeFields.push({
        type: '_sys_tag',
        orgin: 'condition',
        value: tags,
      });
    }
  });

  if (groupData?.list?.length) {
    // 2.分组项
    if (groupBy === 'templateStatus') {
      let value = !groupData.info ? 0 : groupData.info.status;
      changeFields.push({
        type: 'templateStatus',
        value,
        orgin: 'groupBy',
      });
    }
    if (~groupBy.indexOf('templateProp_')) {
      if (groupKey && groupKey !== 'default') {
        const [_, __, propIndex] = groupBy.split('_');
        const propInfo = template.prop[Number(propIndex)];
        changeFields.push({
          type: 'templateProp',
          index: propIndex,
          value: propInfo.multiple ? [groupKey] : groupKey,
          orgin: 'groupBy',
        });
      }
    }
    // 模板状态属性，需要在确定状态的时候，才能赋值
    if (~groupBy.indexOf('templateStatusPropBase_')) {
      // 人员
      const [_, propIndex] = groupBy.split('_');
      let value = Number.isFinite(Number(propIndex))
        ? groupData.list[0].prop._sys_task_status.prop[Number(propIndex)]
        : null;
      if (!propIsNull(value)) {
        changeFields.push({
          type: 'tempStatusProp',
          index: propIndex,
          value: value,
          orgin: 'groupBy',
        });
      }
    }
    if (~groupBy.indexOf('templateStatusPropCustom_')) {
      const [_, propIndex] = groupBy.split('_');
      let value = Number.isFinite(propIndex)
        ? groupData.list[0].prop._sys_task_status.prop[Number(propIndex)]
        : null;
      if (!propIsNull(value)) {
        changeFields.push({
          type: 'tempStatusProp',
          index: propIndex,
          value: value,
          orgin: 'groupBy',
        });
      }
    }
    if (groupBy === '_sys_tag' && groupData.name && groupData.name !== '未定义') {
      changeFields.push({
        type: '_sys_tag',
        orgin: 'groupBy',
        value: [groupData.name],
      });
    }
  }

  // set template prop
  let tempProp = null;
  let sysCascade: any = null;
  const changeTempProp = changeFields.filter((x) => x.type === 'templateProp');
  if (changeTempProp.length) {
    tempProp = new Array(template.prop.length).fill(null);
    changeTempProp.map((option: any) => {
      tempProp[Number(option.index)] = option.value;
      if (option.sysCascade) {
        if (!sysCascade) {
          sysCascade = {};
        }
        sysCascade[option.index] = option.sysCascade;
      }
    });
  }
  // status
  let status = null;
  const changeStatus = changeFields.filter((x) => x.type === 'templateStatus');
  if (changeStatus.length) {
    // 默认的状态，以分组为主
    if (groupBy === 'templateStatus' && groupData.list) {
      const changeStatusByGroup = changeStatus.find((x) => x.orgin === 'groupBy');
      status = changeStatusByGroup?.value;
    } else {
      status = changeStatus[0].value;
    }
  } else if (
    Array.isArray(template.task_status) &&
    template.task_status.find((x) => x && !x.disabled)
  ) {
    status = getDefaultStatus(template);
  }
  // status prop
  let statusProp = null;
  const changeStatusProp = changeFields.filter((x) => x.type === 'tempStatusProp');
  if (changeStatusProp.length) {
    if (status !== null) {
      const tempStatusConfig = template.task_status[status];
      statusProp = new Array(tempStatusConfig.prop.length).fill(null);
      changeStatusProp.map((option) => {
        const propInfo = tempStatusConfig.prop[Number(option.index)];
        let value;
        if (propInfo.multiple) {
          value = Array.isArray(option.value) ? option.value : [option.value];
        } else {
          value =
            Array.isArray(option.value) && option.value.length ? option.value[0] : option.value;
        }
        statusProp[Number(option.index)] = value;
      });
    } else if (changeStatusProp.find((o) => Number(o.index) < 2)) {
      statusProp = [
        changeStatusProp.find((o) => Number(o.index) === 0)?.value || null,
        changeStatusProp.find((o) => Number(o.index) === 1)?.value || null,
      ];
    }
  }

  // sys tag
  let sysTag = null;
  const changeSysTag = changeFields.filter((x) => x.type === '_sys_tag');
  if (changeSysTag.length) {
    const tags = Array.from(
      new Set(
        changeSysTag.reduce((a, b) => {
          return a.concat(b.value);
        }, []),
      ),
    );
    if (tags.length) {
      sysTag = tags;
    }
  }

  const res: any = {};
  if (tempProp !== null) {
    res.tempProp = tempProp;
  }
  if (status !== null) {
    res.status = status;
  }
  if (statusProp !== null) {
    res.statusProp = statusProp;
  }
  if (sysTag !== null) {
    res.sysTag = sysTag;
  }
  if (sysCascade !== null) {
    res.sysCascade = sysCascade;
  }

  return res;
};

// 属性的数据转换
const transformViewOptionPropData = (
  template: ApiResponse.CurrentUser.TemplateInfo,
  propIndex: number,
  propInfo: ApiResponse.CurrentUser.TemplateProp,
  conditionValue: any,
  brotherNodeProp: any[],
) => {
  let value = conditionValue;
  // 筛选值只取1个
  // 属性有默认值，并且筛选值不包含默认值，取筛选值第一个
  // 属性有默认值，并且筛选项包含默认值，取默认值
  // 属性没有默认值，取第一个

  // 数字属性 取上一个（在视图上已存在的节点）节点的值
  // 公式属性，取上一个节点的 计算源 的值
  const isNumberProp = propInfo.type === 'number';
  const isFormulaProp = propInfo.type === 'formula';
  if (isNumberProp) {
    value = brotherNodeProp[propIndex];
    return [{ value, propIndex }];
  } else if (isFormulaProp) {
    const correlationIndex = getFormulaCorrelationIndex(propInfo.formula);
    return correlationIndex.map((index) => ({
      propIndex: index,
      value: brotherNodeProp[propIndex],
    }));
  } else if (propInfo.type === 'cascade') {
    return [{ value, propIndex }];
  } else {
    const propDefaultValue = template.prop?.[propIndex]?.defaultValue;
    if (propDefaultValue !== undefined && propDefaultValue !== null) {
      const conditionValueHasPropDefaultValue = ~conditionValue.indexOf(propDefaultValue);
      if (!conditionValueHasPropDefaultValue) {
        value = value.length ? [value[0]] : [];
      } else {
        value = [propDefaultValue];
      }
    } else {
      value = value.length ? [value[0]] : [];
    }

    if (!propInfo.multiple) {
      value = value.length ? value[0] : null;
    }
    return [{ value, propIndex }];
  }
};

// formulaConfig: input:[],op:''
const getFormulaCorrelationIndex = (formulaConfig: any) => {
  let indexes = new Set();

  formulaConfig.input.map((x: any) => {
    if (x.type === 'formula') {
      getFormulaCorrelationIndex(x.formula).map((i) => indexes.add(i));
    } else {
      indexes.add(x.prop);
    }
  });

  return Array.from(indexes);
};

/**
 * 获取所有children的筛选条件 筛选组 排序条件
 * 1. 系统字段: 创建人，创建时间，修改时间
 * 3. 模板属性
 * 4. 模板状态
 * 5. 模板状态属性
 */
// 过滤条件 1. 系统字段：创建人,创建时间,修改时间  3. 模板属性 4. 模板状态 5. 模板状态属性
// 排序 1. 系统字段里的时间 创建/修改 2. 模板属性的时间类型 3. 模板状态属性的时间类型
// 分组 1. 模板属性、模板状态属性 里的枚举属性/单选人员 2. 状态
export const getViewSettingOptionWithGroup = (
  templateList: ApiResponse.CurrentUser.TemplateInfo[],
  orgInfo: ApiResponse.CurrentUser.OrgInfo,
  tempMap: Record<string, ApiResponse.CurrentUser.TemplateInfo> = {},
  quoteOptions: Record<number, string[]> = {},
) => {
  // 空间权限
  const orgRoles = [...orgInfo.groupList];
  if (orgInfo.role === 1 || orgInfo.role === 3) {
    orgRoles.push('-2');
  }
  // 筛选条件项
  const option: Record<
    string,
    {
      options: any;
      name: string;
      type?: string;
      data?: any;
    }
  > = {
    // 系统属性
    _sys_creator: {
      name: '创建者',
      options: new Set(),
      type: 'user',
    },
    _sys_createTime: {
      name: '创建时间',
      options: new Set(),
      type: 'date',
    },
    _sys_tag: {
      name: '标签',
      options: new Set(),
      type: 'tag',
    },
    // 模板状态
    templateStatus: {
      name: '状态',
      options: [],
    },
    // 历史状态
    /*historyStatus: {
        name: '历史状态',
        options: [],
      },*/
    // 状态流转
    // statusFlow: {
    //   name: '状态流转',
    //   options: [],
    // },
    // 模板属性
    // 模板状态属性
  };

  // 筛选条件项分组
  const optionGroup: Record<string, Set<string>> = {
    sys: new Set(['_sys_creator', '_sys_createTime', '_sys_tag']),
    templateStatus: new Set([
      'templateStatus',
      // 'statusFlow'
    ]),
    templateProp: new Set(),
    templateStatusProp: new Set(),
  };

  const optionGroupKeyMap: Record<string, string> = {
    sys: '系统属性',
    templateStatus: '状态相关',
    // statusFlow: '状态流转',
    templateProp: '属性',
    templateStatusProp: '状态属性',
  };

  // 排序项
  const orderByOption: Record<string, { name: string }> = {
    _sys_createTime: {
      name: '创建时间',
    },
    templateStatus: {
      name: '状态',
    },
    treeLevel: {
      name: '主题树顺序',
    },
    _sys_updateTime: {
      name: '更新时间',
    },
  };

  // 分组项
  let groupOption: Record<
    string,
    {
      name: string;
      data?: any;
      subMenu?: { name: string; key: string }[];
    }
  > = {
    sysCreator: {
      name: '创建人',
    },
    _sys_tag: {
      name: '标签',
    },
    // 模板状态属性前两个为固定
    templateStatusPropBase_0: {
      name: '负责人',
    },
    templateStatus: {
      name: '当前状态',
    },
    dayHours: {
      name: '开始时间',
    },
  };

  if (templateList.length === 0)
    groupOption = {
      template: {
        name: '主题类型',
      },
    };

  templateList?.map((template) => {
    const statusOptions: any = [];
    // 模板属性
    const optionGroupTemplateProp: { key: string; sort: number }[] = [];
    template.prop.map((prop, propIndex) => {
      if (
        !prop ||
        !prop.type
        // || prop.hide
      )
        return;

      // 时间属性 prop.dateFormat HH:mm 隐藏
      if (prop.type === 'date' || prop.type === 'datetime') {
        if (prop.dateFormat === 'HH:mm') {
          return;
        }
      }

      let auth = false;
      const visGroups = prop.visGroups || ['-1'];
      if (visGroups.includes('-1')) {
        auth = true;
      } else {
        visGroups.map((item) => {
          if (orgRoles.includes(item)) {
            auth = true;
          }
        });
      }
      if (!auth) return;

      const key = `templateProp_${template.template_id}_${propIndex}`;
      const optionSet = new Set();
      if (prop.type === 'enum' || prop.type === 'tag') {
        if (Array.isArray(prop.extend) && prop.extend.length) {
          prop.extend
            .filter((i) => typeof i === 'string')
            .forEach((e) => {
              if (e && !optionSet.has(e)) optionSet.add(e);
            });
        }
        if (quoteOptions[propIndex]) {
          quoteOptions[propIndex].forEach((e) => {
            if (e && !optionSet.has(e)) optionSet.add(e);
          });
        }
      }
      option[key] = {
        name: prop.name,
        options: optionSet,
        type: prop.type,
        data: prop,
      };
      optionGroupTemplateProp.push({
        key,
        sort: prop.sort,
      });

      if (
        prop.type === 'date' ||
        prop.type === 'datetime' ||
        prop.type === 'enum' ||
        prop.type === 'number'
      ) {
        orderByOption[key] = {
          name: prop.name,
        };
      }

      if (
        prop.type === 'user' ||
        prop.type === 'enum' ||
        prop.type === 'tag' ||
        prop.type === 'number' ||
        // prop.type === 'cascade' ||
        prop.type === 'text' ||
        prop.type === 'formula'
        // ||
        // prop.type === 'address'
      ) {
        groupOption[key] = {
          name: prop.name,
          data: prop,
        };
      }
      if (prop.type === 'quote') {
        const originalProp = getMatchingOriginProp(prop, tempMap);
        if (
          originalProp &&
          typeof originalProp === 'object' &&
          ((originalProp.type === 'enum' && !originalProp.quoteTempId) ||
            originalProp.type === 'tag' ||
            originalProp.type === 'text' ||
            originalProp.type === 'formula' ||
            originalProp.type === 'user')
        ) {
          groupOption[key] = {
            name: prop.name,
            data: prop,
          };
        }

        // 如果存在选值，加进去！
        // 例如：引用了选值属性，文本，状态
        if (quoteOptions[propIndex]) {
          quoteOptions[propIndex].forEach((e) => {
            if (e && !optionSet.has(e)) optionSet.add(e);
          });
        }
      }
    });
    optionGroup.templateProp = new Set(
      optionGroupTemplateProp.sort((a, b) => a.sort - b.sort).map((x) => x.key),
    );

    // 模板状态
    template.task_status.map((task, taskIndex) => {
      if (!task?.name || task.delete) return;
      statusOptions.push({
        key: `${template.template_id}_${taskIndex}`,
        name: task.name,
        sort: 'sort' in task ? task.sort : taskIndex,
      });

      // 模板状态属性
      task.prop.map((prop, propIndex) => {
        // 关联属性是{index：number}
        if (!prop?.type || prop.type === 'quote') return;
        // 区分基础模板状态属性和模板自定义状态属性
        // 基础属性 [负责人,参与者,开始时间,结束时间,备注]
        // let propKey;
        const propKey = `templateStatusPropBase_${propIndex}`;
        // if (propIndex <= 4) {
        //   propKey = `templateStatusPropBase_${propIndex}`;
        // } else {
        //   propKey = `templateStatusPropCustom_${template.template_id}_${taskIndex}_${propIndex}`;
        // }
        option[propKey] = {
          name: prop.name,
          options: new Set(),
          type: prop.type,
          data: prop,
        };
        optionGroup.templateStatusProp.add(propKey);

        if (prop.type === 'datetime') {
          orderByOption[propKey] = {
            name: prop.name,
          };
        }

        if (prop.type === 'user') {
          let name = '';
          // 模板状态属性前五位固定 负责人,参与者，开始时间，结束时间，备注
          if (propIndex <= 4) {
            if (propIndex === 0) {
              name = '负责人';
            } else if (propIndex === 1) {
              name = '参与者';
            }
          } else {
            name = prop.name;
          }

          groupOption[propKey] = {
            name: name,
            data: prop,
          };
        }
      });
    });
    if (statusOptions.length) {
      statusOptions.sort((b: any, a: any) => b.sort - a.sort);
      option.templateStatus.options.push.apply(option.templateStatus.options, statusOptions);
      // option.historyStatus.options.push.apply(option.historyStatus.options, statusOptions);
    }
  });

  // 增加 负责人 或 参与者 筛选条件
  option.templateStatusOwnerAndParticipant = {
    name: '负责人或参与者',
    type: 'user',
    data: {
      multiple: true,
      name: '负责人或参与者',
      required: false,
      type: 'user',
    },
    options: [],
  };
  optionGroup.templateStatusProp.add('templateStatusOwnerAndParticipant');

  if (templateList.length)
    groupOption['templateStatusOwnerAndParticipant'] = {
      name: '负责人或参与者',
      data: {
        multiple: true,
        name: '负责人或参与者',
        required: false,
        type: 'user',
      },
    };

  // set 转数组再输出
  const resOption: Record<
    string,
    {
      options: { name: string; key: string }[];
      name: string;
      type?: string;
      data?: any;
    }
  > = {};
  Object.keys(option).map((x) => {
    resOption[x] = {
      ...option[x],
      options: Array.from(option[x].options),
    };
  });

  const resOptionGroup: Record<string, string[]> = {};
  Object.keys(optionGroup).map((x) => {
    resOptionGroup[x] = Array.from(optionGroup[x]);
  });

  Object.keys(groupOption).map((x) => {
    switch (groupOption[x].data?.type) {
      case 'user':
        groupOption[x].subMenu = [
          {
            name: '按成员',
            key: x.concat('_0'),
          },
          {
            name: '按成员组',
            key: x.concat('_1'),
          },
        ];
        break;
      case 'cascade':
        if (groupOption[x].data.cascade) {
          groupOption[x].subMenu = Array.from(
            { length: groupOption[x].data.cascade.titles.length },
            (v, i) => {
              return {
                name: `第${i + 1}级`,
                key: x.concat('_', (i + 1).toString()),
              };
            },
          );
        }
        break;
      case 'address':
        const subMenus = [
          {
            name: '省份',
            key: x.concat('_', 'province'),
          },
        ];
        if (groupOption[x].data.accuracy !== 'province') {
          subMenus.push({
            name: '省份/城市',
            key: x.concat('_', 'city'),
          });
          if (groupOption[x].data.accuracy !== 'city') {
            subMenus.push({
              name: '省份/城市/区县',
              key: x.concat('_', 'district'),
            });
            if (groupOption[x].data.accuracy !== 'district') {
              subMenus.push({
                name: '省份/城市/区县/街道',
                key: x.concat('_', 'street'),
              });
            }
          }
        }
        groupOption[x].subMenu = subMenus;
        break;
    }
  });

  const fieldOptionGroup = Object.keys(resOptionGroup).reduce((a, groupKey) => {
    a[groupKey] = {
      name: optionGroupKeyMap[groupKey],
      optionKeys: resOptionGroup[groupKey],
    };
    return a;
  }, {} as Record<string, { name: string; optionKeys: string[] }>);

  return {
    option: resOption,
    optionGroup: resOptionGroup,
    fieldOptionGroup,
    optionGroupKeyMap,
    orderByOption,
    groupOption,
  };
};

/**
 * 视图配置 转成 后端（中间件和接口）的筛选器的数据结构
 */
export const convertViewConfigToFilterConfig = () => {
  // TODO
};

export const fixConditionV2ToFilterConfig = (conditionV2: any, userId: string) => {
  if (conditionV2 && conditionV2.length && conditionV2.length >= 2) {
    conditionV2 = conditionV2.map((x: any, i: number) => {
      if (x.key === 'templateId' || x.key === 'ancestor') {
        x.op = 'intersect';
      } else if (i === 0 || i === 1 || x.key === 'status') {
        x.op = 'intersect';
      } else if (
        i > 1 &&
        x.op === 'timeBein' &&
        (x.input.length > 2 || x.input[0] === x.input[1])
      ) {
        if (x.input.length > 2) {
          //近几日
          const endTime = dayjs(dayjs().format('YYYY/MM/DD') + ' 23:59:59').valueOf();
          const startTime = endTime - (Number(x.input[2]) + 1) * 24 * 60 * 60 * 1000 + 1000;
          x.input = [startTime, endTime];
        } else {
          //开始结束时间
          const startTime = dayjs(dayjs(x.input[0]).format('YYYY/MM/DD') + ' 00:00:00').valueOf();
          const endTime = dayjs(dayjs(x.input[0]).format('YYYY/MM/DD') + ' 23:59:59').valueOf();
          x.input = [startTime, endTime];
        }
      } else if (x?.extends?.type === 'text') {
        x.op = 'textInclude';
      } else if (x?.extends?.type === 'user' && x.input.length === 1 && x.input[0] === null) {
        x.input = [userId];
      } else if (
        x.key === 'sysCreator' ||
        (x.key === 'statusProp' && (x.index === 0 || x.index === 1)) ||
        x.key === 'templateStatusOwnerAndParticipant'
      ) {
        if (Array.isArray(x.input)) {
          x.input = x.input.map((y: any) => (y === null ? userId : y));
        } else {
          x.input = x.input === null ? userId : x.input;
        }
      }
      return x;
    });
  }
  return conditionV2;
};
